<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de paciente por bairro">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/cadastro/relatorio-paciente-bairro/List'

export default {
    components: { List },
}
</script>